import Vue from 'vue'
import { UsersWebPushSubscribeURL, UsersWebPushUnsubscribeURL } from './api'
import { VAPID_PUBLIC_KEY } from '../config'
import store from '../vuex/store'

export default {
    initialized: false,
    init () {
        this.initialized = true;
        if (!('serviceWorker' in navigator)) {
            console.log('Service workers aren\'t supported in this browser.')
            return
        }

        if (!('showNotification' in window.ServiceWorkerRegistration.prototype)) {
            console.log('Notifications aren\'t supported.')
            return
        }
        if (window.Notification.permission === 'denied') {
            console.log('The user has blocked notifications.')
            return
        }
        if (!('PushManager' in window)) {
            console.log('Push messaging isn\'t supported.')
            return
        }
        navigator.serviceWorker.ready.then(registration => {
            registration.pushManager.getSubscription()
                .then(subscription => {
                    if (!subscription) {
                        this.subscribe()
                        return
                    }
                    this.updateSubscription(subscription)
                })
                .catch(e => {
                    console.log('Error during getSubscription()', e)
                })
        })
    },

    /**
     * Subscribe for push notifications.
     */
    subscribe () {
        navigator.serviceWorker.ready.then(registration => {
            const options = {
                userVisibleOnly: true,
                applicationServerKey: this.urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
            }
            registration.pushManager.subscribe(options)
                .then(subscription => {
                    this.updateSubscription(subscription)
                })
                .catch(e => {
                    console.log('Unable to subscribe to push.', e)
                })
        })
    },

    /**
     * Unsubscribe from push notifications.
     */
    unsubscribe () {
        this.initialized = false
        navigator.serviceWorker.ready.then(registration => {
            registration.pushManager.getSubscription().then(subscription => {
                if (!subscription) {
                    return
                }
                subscription.unsubscribe().then(() => {
                    this.deleteSubscription(subscription)
                }).catch(e => {
                    console.log('Unsubscription error: ', e)
                })
            })
        })
    },

    /**
     * Send a request to the server to update user's subscription.
     *
     * @param {PushSubscription} subscription
     */
    updateSubscription (subscription) {
        const key = subscription.getKey('p256dh')
        const token = subscription.getKey('auth')
        const data = {
            endpoint: subscription.endpoint,
            key: key ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
            token: token ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
        }

        Vue.http.post(UsersWebPushSubscribeURL, data, {
            headers: {
                'Authorization': 'Bearer ' + store.state.accessToken
            }
        })
    },

    /**
     * Send a requst to the server to delete user's subscription.
     *
     * @param {PushSubscription} subscription
     */
    deleteSubscription (subscription) {
        // It doesn't matter too much if this fails, as the server will delete the subscription
        // if it has been unsubscribed next time it attempts to push to it
        Vue.http.post(UsersWebPushUnsubscribeURL, { endpoint: subscription.endpoint }, {
            headers: {
                'Authorization': 'Bearer ' + store.state.accessToken
            }
        })
    },

    /**
     * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
     *
     * @param  {String} base64String
     * @return {Uint8Array}
     */
    urlBase64ToUint8Array (base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/')
        ;
        const rawData = window.atob(base64);
        return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
    }
}
